module.exports = __webpack_public_path__ + "img/undraw_laravel_and_vue_-59-tp.3e5e2485.svg";